import React from 'react';
import { ContentWarp, OutletContentWarp } from './content.style';
import { Outlet } from 'react-router-dom';

export default function DisplayContent() {
  return (
    <OutletContentWarp className='af-display-content-wrap'>
      <ContentWarp className='af-display-content'>
        <Outlet />
      </ContentWarp>
    </OutletContentWarp>
  );
}
